// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__PvENV","circle":"Icon_circle__yhUIM","iconColor":"Icon_iconColor__74OAQ"};